import * as React from 'react';
import type { GetServerSidePropsResult, NextPage } from 'next';

import { Recipe } from '@src/firebase/types';
import { ViewRecipe } from '@src/routes/recipes/components/ViewRecipe';
import { getRecipe } from '@src/routes/recipes/firestore/get-recipe';

interface ViewRecipePageProps {
  recipe: Recipe;
}

const ViewRecipePage: NextPage<ViewRecipePageProps> = (props) => {
  const { recipe } = props;

  return <ViewRecipe recipe={recipe} />;
};

export async function getServerSideProps({
  params,
}: {
  params: { recipeUrl: string };
}): Promise<GetServerSidePropsResult<ViewRecipePageProps>> {
  const { recipeUrl } = params;
  if (!recipeUrl) {
    // TODO gavalas 404 page?
    throw new Error('No with that name!');
  }

  return {
    props: {
      recipe: await getRecipe(recipeUrl),
    },
  };
}

export default ViewRecipePage;

// export async function getStaticProps({
//   params,
// }: {
//   params: { recipeUrl: string };
// }): Promise<GetStaticPropsResult<ViewRecipePageProps>> {
//   const { recipeUrl } = params;
//   if (!recipeUrl) {
//     // TODO gavalas 404 page?
//     throw new Error('No with that name!');
//   }

//   return {
//     props: {
//       recipe: await getRecipe(recipeUrl),
//     },
//     revalidate: 60,
//   };
// }

// export async function getStaticPaths(): Promise<GetStaticPathsResult> {
//   const recipes = await getPublishedRecipes();
//   const paths = recipes.map((recipe) => ({
//     params: {
//       recipeUrl: recipe.friendlyUrl,
//     },
//   }));

//   return {
//     fallback: 'blocking',
//     paths,
//   };
// }

// export default ViewRecipePage;
